import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let moduleEl = this.el;
        let navButtons = moduleEl.querySelectorAll('[data-nav-lvl]');
        let navResets = moduleEl.querySelectorAll('[data-nav-reset]');

        navButtons.forEach(item => {
            if(item.dataset.navLvl !== null && item.dataset.navId !== null){
                item.addEventListener('click', (e) => {
                    let itemLvl = item.dataset.navLvl;
                    let itemID = item.dataset.navId;
                    e.preventDefault();

                    //Toggle Off all active panels above
                    moduleEl.setAttribute('data-nav-' + itemLvl, 0);
                    moduleEl.setAttribute('data-nav-' + itemLvl + 'i', 0);
                    moduleEl.setAttribute('data-nav-' + itemLvl + 'ii', 0);

                    if (moduleEl.getAttribute('data-nav-' + itemLvl) === itemID) {
                        
                        // Reset active classes above
                        moduleEl.querySelectorAll('[data-nav-lvl="' + itemLvl + '"].is-active, [data-nav-lvl="' + itemLvl + 'i"].is-active,[data-nav-lvl="' + itemLvl + 'ii"].is-active').forEach(activeLink => {
                            activeLink.classList.remove('is-active');
                        });
                        item.classList.remove('is-active');
                    }else{

                        let previousActive = moduleEl.querySelector('[data-nav-lvl="' + itemLvl + '"].is-active');
                        if (previousActive !== null) {
                            previousActive.classList.remove('is-active');
                        }

                        moduleEl.setAttribute('data-nav-' + itemLvl, itemID);
                        item.classList.add('is-active');
                    }
                    
                });
            }
        });
        
        navResets.forEach(item => {
            if(item.dataset.navReset !== null){
                item.addEventListener('click', (e) => {
                    let itemReset = item.dataset.navReset;
                    e.preventDefault();
                    // Reset all lvls above
                    moduleEl.setAttribute('data-nav-' +itemReset, '0');
                    moduleEl.setAttribute('data-nav-' +itemReset+'i', '0');
                    moduleEl.setAttribute('data-nav-' +itemReset+'ii', '0');
                    // Reset active classes above

                    let previousActive = moduleEl.querySelector('[data-nav-lvl="' + itemReset + '"].is-active');
                    if(previousActive !== null){
                        previousActive.classList.remove('is-active');
                    }

                    moduleEl.querySelectorAll('[data-nav-' + itemReset + '-id] .is-active, [data-nav-' + itemReset + 'i-id] .is-active,[data-nav-' + itemReset + 'ii-id] .is-active').forEach(activeLink => {
                        activeLink.classList.remove('is-active');
                    });
                });
            }
        });
    }
}